import { MarketingLayout } from '@/layouts/MarketingLayout'

export default function Terms() {
  return (
    <MarketingLayout>
      <div className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-3xl font-bold mb-8">Términos y Condiciones</h1>
        <p className="text-muted-foreground mb-8">Última actualización: 17 de mayo de 2026</p>

        <div className="prose prose-invert max-w-none space-y-6 text-foreground/90">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Uso del servicio</h2>
            <p>
              Tippy es una plataforma para ayudar a negocios a gestionar citas, disponibilidad,
              clientes, recordatorios e integraciones de comunicación. Al usar Tippy, aceptas usar
              el servicio de forma legal, responsable y de acuerdo con estos términos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">2. Cuenta y seguridad</h2>
            <p>
              Eres responsable de mantener la seguridad de tu cuenta, controlar el acceso de tu equipo
              y verificar que la información de tu negocio, horarios, servicios y calendarios sea correcta.
              Si detectas uso no autorizado, contáctanos de inmediato.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">3. Citas, clientes e integraciones</h2>
            <p>
              Tippy puede conectarse con servicios externos, como WhatsApp Business, Google Calendar,
              proveedores de notificaciones y servicios de pago. Estas integraciones dependen de terceros
              y pueden estar sujetas a sus propios términos, políticas y disponibilidad.
            </p>
            <p className="mt-2">
              Eres responsable de obtener los permisos necesarios para registrar datos de clientes,
              enviar comunicaciones y sincronizar calendarios o citas mediante estas integraciones.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">4. Disponibilidad del servicio</h2>
            <p>
              Trabajamos para mantener Tippy disponible y funcionando correctamente, pero no garantizamos
              que el servicio sea ininterrumpido o libre de errores. Podemos realizar mantenimiento,
              actualizaciones o cambios para mejorar la plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">5. Pagos y planes</h2>
            <p>
              Algunas funciones pueden requerir un plan pagado o créditos adicionales. Los precios,
              límites y condiciones comerciales se muestran en la plataforma o en nuestras páginas públicas.
              Podemos actualizar planes o precios con aviso razonable cuando corresponda.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">6. Datos y privacidad</h2>
            <p>
              El tratamiento de datos personales se describe en nuestra{' '}
              <a href="/privacy" className="text-primary hover:underline">Política de Privacidad</a>.
              Al usar Tippy, aceptas que procesemos información conforme a dicha política para prestar
              y mejorar el servicio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">7. Limitación de responsabilidad</h2>
            <p>
              En la medida permitida por la ley, Tippy no será responsable por pérdidas indirectas,
              interrupciones de negocio, errores de terceros o decisiones tomadas con base en información
              configurada incorrectamente por el usuario.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">8. Cambios a estos términos</h2>
            <p>
              Podemos actualizar estos términos ocasionalmente. Publicaremos la versión vigente en esta
              página e indicaremos la fecha de última actualización.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">9. Contacto</h2>
            <p>
              Si tienes preguntas sobre estos términos, contáctanos en{' '}
              <a href="mailto:emiliano@tippy.com.mx" className="text-primary hover:underline">
                emiliano@tippy.com.mx
              </a>.
            </p>
          </section>
        </div>
      </div>
    </MarketingLayout>
  )
}
